/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BranchTagAdminDto } from '../models/BranchTagAdminDto';
import type { GetBranchTagsClientResponse } from '../models/GetBranchTagsClientResponse';
import type { Language } from '../models/Language';
import type { ListOf1OfBranchAdminListedDto } from '../models/ListOf1OfBranchAdminListedDto';
import type { Pagination1OfBranchTagAdminListedDto } from '../models/Pagination1OfBranchTagAdminListedDto';
import type { PostBranchTagRequestAdmin } from '../models/PostBranchTagRequestAdmin';
import type { PutBranchesRequestAdmin } from '../models/PutBranchesRequestAdmin';
import type { PutBranchTagRequestAdmin } from '../models/PutBranchTagRequestAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BranchTagsService {
    /**
     * @returns GetBranchTagsClientResponse OK
     * @throws ApiError
     */
    public static getBranchTagsClient({
        channelId,
    }: {
        channelId: number,
    }): CancelablePromise<GetBranchTagsClientResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/branchtags',
            query: {
                'channelId': channelId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetBranchTagsClientResponse OK
     * @throws ApiError
     */
    public static getPublicBranchTagsClient({
        channelId,
        language,
    }: {
        channelId: number,
        language?: Language,
    }): CancelablePromise<GetBranchTagsClientResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/branchtags/public',
            query: {
                'channelId': channelId,
                'language': language,
            },
        });
    }
    /**
     * **Required Policy:** `ViewBranchTagBranches`
     * @returns ListOf1OfBranchAdminListedDto OK
     * @throws ApiError
     */
    public static getBranchesByBranchTagAdmin({
        branchTagId,
    }: {
        branchTagId: number,
    }): CancelablePromise<ListOf1OfBranchAdminListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/branchtags/{branchTagId}/branches',
            path: {
                'branchTagId': branchTagId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageBranchTags`
     * @returns any OK
     * @throws ApiError
     */
    public static putBranchesAdmin({
        branchTagId,
        requestBody,
    }: {
        branchTagId: number,
        requestBody?: PutBranchesRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/branchtags/{branchTagId}/branches',
            path: {
                'branchTagId': branchTagId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewBranchTags`
     * @returns BranchTagAdminDto OK
     * @throws ApiError
     */
    public static getBranchTagAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<BranchTagAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/branchtags/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageBranchTags`
     * @returns BranchTagAdminDto OK
     * @throws ApiError
     */
    public static putBranchTagAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutBranchTagRequestAdmin,
    }): CancelablePromise<BranchTagAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/branchtags/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteBranchTags`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteBranchTagAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/branchtags/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewBranchTags`
     * @returns Pagination1OfBranchTagAdminListedDto OK
     * @throws ApiError
     */
    public static getBranchTagsAdmin({
        channelIds,
        id,
        name,
        isActive,
        branchTagIds,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        channelIds?: Array<number>,
        id?: number,
        name?: string,
        isActive?: boolean,
        branchTagIds?: Array<number>,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfBranchTagAdminListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/branchtags',
            query: {
                'channelIds': channelIds,
                'id': id,
                'name': name,
                'isActive': isActive,
                'branchTagIds': branchTagIds,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageBranchTags`
     * @returns BranchTagAdminDto Created
     * @throws ApiError
     */
    public static postBranchTagAdmin({
        requestBody,
    }: {
        requestBody?: PostBranchTagRequestAdmin,
    }): CancelablePromise<BranchTagAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/branchtags',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
